// DS Toast 전역 브리지
// - DS 의 Toast 는 imperative API 가 없고 상태 기반(앱 루트에 ToastContainer + Toast)이다.
// - 모듈 어디서나 호출하던 `toast.success/error/...` 를 그대로 쓰되, 여기서 pub/sub 로
//   앱 루트의 DSToastHost 에 전달해 DS Toast 로 렌더한다. (react-toastify 대체)

let listeners = [];
let counter = 0;

function emit(type, message) {
    const id = ++counter;
    const entry = { id, type, message };
    listeners.forEach((fn) => fn(entry));
    return id;
}

// react-toastify 와 동일한 호출부(toast.success/error/warn/info) 호환.
// DS ToastType = 'info' | 'success' | 'warning' | 'error' → warn 은 warning 으로 매핑.
export const toast = {
    success: (message) => emit('success', message),
    error: (message) => emit('error', message),
    warn: (message) => emit('warning', message),
    warning: (message) => emit('warning', message),
    info: (message) => emit('info', message),
};

export function subscribeToasts(fn) {
    listeners.push(fn);
    return () => {
        listeners = listeners.filter((l) => l !== fn);
    };
}

export default toast;
